// extracted by mini-css-extract-plugin
export default {"imageContainer":"daa-z","summaryPar":"eaa-z","ratingCategories":"faa-z","reviewerInfo":"gaa-z","reviewTypes":"haa-z","expanded":"iaa-z"};